// Export payload for the menu-test block: everything the pptx getMenuTestParams /
// summary / download exporters read off the block beyond the model attrs — the menu view the
// heatmap composite is drawn by, the sections/products metrics the slide is titled with and
// the shared sort order.
export const calcExportData = ({ menuViewMode, sectionsViewMode, productViewMode, sortOrder } = {}) => ({
  menuViewMode,
  sectionsViewMode,
  productViewMode,
  sortOrder
})
